/* Роли для которых кабинет доступен */
export const GUEST = 'guest'
export const LISTENER = 'listener'
export const TEACHER = 'teacher'

const roles = [GUEST, LISTENER]

export const isGuest = (role: string) => GUEST === role
export const isListener = (role: string) => LISTENER === role
export const isTeacher = (role: string) => TEACHER === role
export const isExistRole = (role = 'guest') => roles.includes(role)
